/* V3 adapter for the current shared Dr Sknn menu. The shared menu owns its UI. */
(function () {
  "use strict";
  function init() {
    var root = document.querySelector("[data-drsknn-paid-v3]");
    var details = root && root.querySelector("[data-paid-v3-site-menu]");
    if (!details || details.dataset.paidV3MenuReady === "true") return;
    details.dataset.paidV3MenuReady = "true";
    var summary = details.querySelector("summary");
    var title = details.querySelector("#drsknn-menu-v2-title");
    var inertState = [];
    if (summary) { summary.setAttribute("aria-controls", "menu-drawer"); summary.setAttribute("aria-haspopup", "dialog"); }
    if (title) title.setAttribute("tabindex", "-1");

    function applyInert() {
      inertState.forEach(function (entry) { entry.node.inert = entry.wasInert; });
      inertState = [];
      if (!details.open) return;
      var header = root.querySelector("[data-paid-v3-header]");
      Array.prototype.forEach.call(root.children, function (node) {
        if (node !== header && node.tagName !== "SCRIPT" && node.tagName !== "STYLE") {
          inertState.push({ node: node, wasInert: node.inert }); node.inert = true;
        }
      });
      var menuSlot = details.closest(".paid-v3-site-menu");
      if (menuSlot && menuSlot.parentElement) Array.prototype.forEach.call(menuSlot.parentElement.children, function (node) {
        if (node !== menuSlot) { inertState.push({ node: node, wasInert: node.inert }); node.inert = true; }
      });
    }
    details.addEventListener("toggle", applyInert);
    // The shared Back control focuses the dialog title, which is outside its tab order.
    // Keep reverse tabbing from that title (or outside the panel) inside the V3 dialog.
    document.addEventListener("keydown", function (event) {
      if (!details.open || event.key !== "Tab") return;
      var panel = details.querySelector(".drsknn-menu-v2__panel");
      if (!panel || (document.activeElement !== title && panel.contains(document.activeElement))) return;
      var items = Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (node) {
        return !node.hidden && node.offsetParent !== null;
      });
      if (!items.length) return;
      event.preventDefault();
      (event.shiftKey ? items[items.length - 1] : items[0]).focus();
    }, true);

    function closeMenu() {
      details.open = false;
      if (summary) summary.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("drsknn-menu-v2-open");
      document.body.classList.remove("drsknn-menu-v2-open", "overflow-hidden-tablet");
      applyInert();
    }
    function trackedUrl(value) {
      var url;
      try { url = new URL(value, window.location.href); } catch (_) { return ""; }
      if (url.protocol !== "https:" || ["drsknn.com", "www.drsknn.com", "drsknn.uk", "www.drsknn.uk"].indexOf(url.hostname) < 0) return "";
      try {
        if (window.DRSKNN_ATTRIBUTION && typeof window.DRSKNN_ATTRIBUTION.decorateUrl === "function") {
          url = new URL(window.DRSKNN_ATTRIBUTION.decorateUrl(url.href) || url.href);
        }
      } catch (_) {}
      var current = new URLSearchParams(window.location.search);
      ["gclid", "gbraid", "wbraid", "msclkid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "fbclid", "ttclid"].forEach(function (key) {
        var value = current.get(key);
        if (value && !url.searchParams.has(key)) url.searchParams.set(key, value.slice(0, 300));
      });
      return url.href;
    }
    // Capture before the shared tree's legacy inline consultation callback; the V3 layout has no homepage modal.
    details.addEventListener("click", function (event) {
      var target = event.target.closest && event.target.closest("[data-drsknn-v5-consultation], [data-drsknn-menu-v2-treatment]");
      if (target && details.contains(target)) {
        var consultation = target.hasAttribute("data-drsknn-v5-consultation");
        var existing = consultation && root.querySelector('[data-drsknn-paid-cta="booking-doctor"]');
        var value = existing ? existing.href : details.getAttribute(consultation ? "data-paid-v3-menu-consultation-url" : "data-paid-v3-menu-treatment-url");
        var destination = trackedUrl(value);
        if (!destination) return;
        event.preventDefault(); event.stopImmediatePropagation(); closeMenu();
        window.location.assign(destination);
        return;
      }
      var link = event.target.closest && event.target.closest("a[href][data-drsknn-menu-v2-destination]");
      if (link && details.contains(link)) {
        var decorated = trackedUrl(link.href);
        if (decorated) link.href = decorated;
      }
    }, true);
    applyInert();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();
